var _rect, _rect2, _mask, _rect3, _mask2, _rect4, _mask3, _rect5, _mask4, _rect6, _mask5, _rect7, _mask6, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageMachineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 34,
    height: 42,
    rx: 3,
    stroke: "#00BAB5",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 33,
    width: 14,
    height: 6,
    rx: 1,
    stroke: "#00BAB5",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1053_3087",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 4,
    height: 6,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 4,
    height: 6,
    rx: 1,
    stroke: "#00BAB5",
    strokeWidth: 4,
    mask: "url(#path-3-inside-1_1053_3087)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_1053_3087",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 4,
    height: 6,
    rx: 1
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 20,
    width: 4,
    height: 6,
    rx: 1,
    stroke: "#00BAB5",
    strokeWidth: 4,
    mask: "url(#path-4-inside-2_1053_3087)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_1053_3087",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 10,
    width: 4,
    height: 6,
    rx: 1
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 10,
    width: 4,
    height: 6,
    rx: 1,
    stroke: "#00BAB5",
    strokeWidth: 4,
    mask: "url(#path-5-inside-3_1053_3087)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-4_1053_3087",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 4,
    height: 6,
    rx: 1
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 4,
    height: 6,
    rx: 1,
    stroke: "#00BAB5",
    strokeWidth: 4,
    mask: "url(#path-6-inside-4_1053_3087)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-5_1053_3087",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 4,
    height: 6,
    rx: 1
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 10,
    width: 4,
    height: 6,
    rx: 1,
    stroke: "#00BAB5",
    strokeWidth: 4,
    mask: "url(#path-7-inside-5_1053_3087)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-6_1053_3087",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 4,
    height: 6,
    rx: 1
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 4,
    height: 6,
    rx: 1,
    stroke: "#00BAB5",
    strokeWidth: 4,
    mask: "url(#path-8-inside-6_1053_3087)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageMachineIcon);
export default __webpack_public_path__ + "static/media/manage-machine-icon.d75c8708bc7510c018eb7cefeb60f933.svg";
export { ForwardRef as ReactComponent };